import React from 'react';
import '../less/credits_new.less';
import activeCredits from '../enums/credit/active_credits.json';
import archiveCredits from '../enums/credit/archive_credits.json';
import ProductList from '../../../auxiliary-components/shared/ProductList';

export default function template() {
  const page = 'credit-list';

  return (
    <div className="credit-list">
      <ProductList
        title="CREDIT_LIST_ACTIVE_TITLE"
        items={activeCredits}
        page={page}
      />
      <ProductList
        title="CREDIT_LIST_ARCHIVE_TITLE"
        titleTag="h2"
        itemTitleTag="h3"
        items={archiveCredits}
        page={page}
      />
    </div>
  );
}
